import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React from 'react';
import cls from 'classnames';
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/empty/constants';
import '@douyinfe/semi-foundation/lib/es/empty/empty.css';
import Typography from '../typography';
import BaseComponent from '../_base/baseComponent';
const prefixCls = cssClasses.PREFIX;
export default class Empty extends BaseComponent {
  constructor(props) {
    super(props);

    this.observe = mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'theme-mode') {
          this.updateMode();
        }
      }
    };

    this.updateMode = () => {
      const val = this.body.getAttribute('theme-mode');

      if (val !== this.state.mode) {
        this.setState({
          mode: val
        });
      }
    };

    this.state = {
      mode: null
    };
  }

  componentDidMount() {
    if (this.props.darkModeImage) {
      this.body = window.document.body;
      this.updateMode();
      const config = {
        attributes: true,
        childList: false,
        subtree: false
      };
      this.observer = new MutationObserver(this.observe);
      this.observer.observe(this.body, config);
    }
  }

  componentWillUnmount() {
    this.observer && this.observer.disconnect();
  }

  render() {
    var _context;

    const {
      className,
      image,
      description,
      style,
      title,
      imageStyle,
      children,
      layout,
      darkModeImage
    } = this.props;
    const alt = typeof description === 'string' ? description : 'empty';
    const imgSrc = this.state.mode && darkModeImage ? darkModeImage : image;
    let imageNode = null;

    if (typeof imgSrc === 'string') {
      imageNode = /*#__PURE__*/React.createElement("img", {
        alt: alt,
        src: imgSrc
      });
    } else if (imgSrc && 'id' in imgSrc) {
      imageNode = /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#".concat(imgSrc.id)
      }));
    } else {
      imageNode = imgSrc;
    }

    const wrapperCls = cls(className, prefixCls, {
      [_concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, layout)]: layout
    });
    const titleProps = imageNode ? {
      heading: 4
    } : {
      heading: 6,
      style: {
        fontWeight: 400
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      className: wrapperCls,
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-image"),
      style: imageStyle
    }, imageNode), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, title ? /*#__PURE__*/React.createElement(Typography.Title, _Object$assign({}, titleProps, {
      className: "".concat(prefixCls, "-title")
    }), title) : null, description ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-description")
    }, description) : null, children ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, children) : null));
  }

}
Empty.defaultProps = {
  layout: 'vertical'
};